const KEY = 'shopCart';

function parseCart(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function readShopCart() {
  let raw = sessionStorage.getItem(KEY);

  if (!raw) {
    const legacy = localStorage.getItem(KEY);
    if (legacy) {
      const parsed = parseCart(legacy);
      if (parsed && parsed.length > 0) {
        sessionStorage.setItem(KEY, legacy);
      }
      localStorage.removeItem(KEY);
      raw = sessionStorage.getItem(KEY);
    }
  }

  const parsed = parseCart(raw);
  if (parsed === null && raw) {
    sessionStorage.removeItem(KEY);
    return [];
  }
  return parsed || [];
}

export function writeShopCart(cart) {
  if (Array.isArray(cart) && cart.length > 0) {
    sessionStorage.setItem(KEY, JSON.stringify(cart));
  } else {
    sessionStorage.removeItem(KEY);
  }
}

export function clearShopCart() {
  sessionStorage.removeItem(KEY);
}
